import { render, staticRenderFns } from "./BaseStyleComponent.vue?vue&type=template&id=0827fcbf&scoped=true&"
import script from "./BaseStyleComponent.vue?vue&type=script&lang=js&"
export * from "./BaseStyleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827fcbf",
  null
  
)

export default component.exports